import React, { useContext } from 'react';
import { Button } from '@/components';
import { viewportContext } from '@/context/viewport.context';
import t from '@/utils/Language/UI-translations';

const EditModeButton = ({ onButtonClick, additionalClasses }) => {
  const { isMobileOrTablet } = useContext(viewportContext);

  return (
    <Button
      type="default"
      icon={{ style: 'fas', font: 'pen-to-square' }}
      text={t('Edit')}
      additionalClasses={additionalClasses}
      styles={{ width: isMobileOrTablet ? 'full' : '' }}
      onButtonClick={onButtonClick}
    />
  );
};

export default EditModeButton;
